import { sideMenu } from 'menu'
import date from 'menu/DateMenu/reducer'
import { combineReducers } from 'redux'

export default combineReducers({
  sideMenu,
  date,
})
